
import moment from "moment";
import PlaceCard from '@/components/PlaceCard'
import PlaceCardv2 from '@/components/PlaceCardv2'
import ShimmerEffect from "@/components/ShimmerEffect.vue";
export default {
  scrollToTop: true,
  layout: 'home',
  components: {
    PlaceCard,
    PlaceCardv2,
    ShimmerEffect
  },
  head() {
    return {
      title: this.title + " | Goa App",
      meta: [{
        hid: 'description',
        name: 'description',
        content: this.description
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: `Goa, Goa Tourism, Travel Guide, Watersports, must visit places, Must do activities, Watesports, Scuba diving, Parasailing, Dudhsagar Waterfalls Tour, Grand Island Goa, Cheap, Discount, Old Goa Churches, Offers, Travel Goa, Visit goa, Car rentals, Bike Rentals, Top things to do in Goa, Travel Agency, places to visit in goa,goa tourism, goa tourist places, best places to visit in goa, goa places, goa best places, must visit places in goa, places to see in goa, goa travel, goa activities, goa itinerary, goa adventure, best tourist places in goa, goa tour guide, goa visit, activities to do in goa, goa adventure activities, goa travel guide, goa travel places, goa guide, see goa, must see places in goa, places to roam in goa, best of goa, best places to see in goa, adventure places in goa, itinerary for goa trip, goa activities to do, best itinerary for goa, best city in goa, goa trip guide, goa trip places, goa tour itinerary, to do in goa, must do in goa, must visit in goa, tourist places to visit in goa, best goa, goa tour places to visit, goa best visit place, goa see, goa to visit places, adventures to do in goa, must see in goa, goa roaming places, best to visit goa, travel itinerary goa, travel for goa, about goa tourist places, tourist activities in goa, places to visit from goa, goa vacation places, best goa trip, goa city tourist places, best city to visit in goa, goa in best places, goa we, goa trip places to visit, holiday places in goa, goa city guide, best place for goa, best places to roam in goa, best goa places to visit, in goa best places, places to in goa, goa trip best places, travel itinerary for goa, goa cities to visit, best adventure places in goa, best places to travel in goa, goa places to roam, itinerary to goa, goa holiday guide, cities in goa to visit, goa places for visit, goa tourism app, best to visit in goa, best tourist places to visit in goa, must visit goa places, do goa, goa in tourist places, best activities to do in goa, in goa best places to visit, goa you, must do activities in goa, best place to roam in goa, best goa tour, places in goa must visit, places you must visit in goa, adventure places to visit in goa, goa best places to see, places to do in goa, www goa tourism places, best place for visit in goa, adventure to do in goa, best goa tourist places, you goa, goa which places to visit, goa best places for visit, the best places to visit in goa, must place to visit in goa, best to do in goa, goa tour goa, best visit in goa, activities in goa for tourists, goa tourism best places to visit, the best goa, goa guided tour, best tourist places of goa, best places in goa for visit, travel and tourism guide, best places to in goa, goa city tour places, guide to goa trip, goa visit guide, the places to visit in goa, places goa to visit, visit to goa places, goa places must visit, the best place to visit in goa, see in goa, must visit goa, we goa, places in goa to roam, to see in goa, goa in place, goa place for visit, goa vacation trip, goa tourism best places, goa to see places, tourism places of goa, goa tourist visit places, must to visit places in goa, best tourist city in goa, goa in best place`
      },
      {
        hid: 'image',
        property: 'image',
        content: 'https://goa.app/android-chrome-384x384.png'
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: this.title + " | Goa App"
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: 'https://goa.app/android-chrome-384x384.png'
      },
      {
        hid: 'og:image:secure_url',
        property: 'og:image:secure_url',
        content: 'https://goa.app/android-chrome-384x384.png'
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: this.description
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: this.title + " | Goa App"
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: this.description
      }
      ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      // To store page section data populated from API
      title: "Goa Tourism Travel Guide",
      description: 'Goa App | Discover Beaches, Churches, Dudhsagar Waterfalls Tour, Parasailing, Watersports Activities, Scuba Diving, Grand Island Tour, Car Rentals in Goa.',
      search: null,
      hasPrev: false,
      hasNext: true,
      left: 0,
      originX: 0,
      originLeft: 0,
    };
  },

  destroyed() {
    document.body.classList.remove('modalOverflow')
    if (document.getElementById('locationClose'))
      document.getElementById('locationClose').click();
  },
  mounted() {
    if (localStorage.getItem('placesFilter')) {
      localStorage.removeItem('placesFilter');
    }
    if (localStorage.getItem('activitiesFilter')) {
      localStorage.removeItem('activitiesFilter');
    }
    if (localStorage.getItem('blogsFilter')) {
      localStorage.removeItem('blogsFilter');
    }
    if (localStorage.getItem('ticketsFilter')) {
      localStorage.removeItem('ticketsFilter');
    }
    if (localStorage.getItem('reviewsFilter')) {
      localStorage.removeItem('reviewsFilter');
    }
    if (localStorage.getItem('searchFilter')) {
      localStorage.removeItem('searchFilter');
    }
  },

  methods: {

    //##Vue Scroll
    prev() {
      this.$refs.horizontal.prev()
    },
    next() {
      this.$refs.horizontal.next()
    },
    onScrollDebounce({
      hasPrev,
      hasNext
    }) {
      this.hasPrev = hasPrev
      this.hasNext = hasNext
    },
    onScroll({
      left
    }) {
      this.left = left
    },
    onMouseDown(e) {
      this.originX = e.pageX
      this.originLeft = this.left
      window.addEventListener("mouseup", this.onMouseUp);
      window.addEventListener("mousemove", this.onMouseMove);
    },
    onMouseUp() {
      window.removeEventListener("mouseup", this.onMouseUp);
      window.removeEventListener("mousemove", this.onMouseMove);
    },
    onMouseMove(e) {
      const offset = e.pageX - this.originX
      const left = this.originLeft - offset
      this.$refs.horizontal.scrollToLeft(left, 'auto')
    },
    // #End VueScroll
    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/places.svg`)
    },
  },
}
